import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { RoleEditSchema } from '../RoleSchema'
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'ROLE';

export function RoleAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Role");
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [role, setRole] = useState({
        groupID: 0,
        roleLevel: 0,
        operationEntityID: 0,
        name: '',
        isActive: true
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(RoleEditSchema).options({ allowUnknown: true });
    const [roleLevel, setRoleLevel] = useState();

    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Role");
            setRole({
                groupID: props.location.data.groupID,
                roleLevel: props.location.data.roleLevel,
                operationEntityID: props.location.data.operationEntityID,
                name: props.location.data.name,
                isActive: props.location.data.isActive
            })
            setButtonName("Update")
        } else {
            setTitle("Add Role");
        }
    }, [])

    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
        )
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [role.groupID]);

    useEffect(() => {

        getRoleLevelsForDropDown()

    }, []);



    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITROLE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Role");
            setRole(data)
            setButtonName("Update")
        } else {
            setTitle("Add Role");
            var token = tokenService.getUserDetailsFromToken();
            setRole({
                ...role,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getRoleLevelsForDropDown() {
        const roleLevel = await services.getAlllRoleLevels();
        setRoleLevel(roleLevel);
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await services.getAllOperationEntitiesForDropDown(role.groupID);
        setOperationEntity(operationEntities);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.name === 'isActive' ? target.checked : target.value

        if (target.name === "groupID") {
            if (target.value.length === 5) return false
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, RoleEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setRole({
            ...role,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, role);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            var result = await services.saveRole(role);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        } else if (edit) {
            var result = await services.editData(role);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/role' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setRole({
            ...role,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            name: '',
            isActive: true,
            roleLevel: 0
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/role"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={(edit && data) ? true : !permissionList.isGroupFilterEnabled}
                                            value={role.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={(edit && data) ? true : !permissionList.isOperationEntityFilterEnabled}
                                            value={role.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="roleLevel">Role Level *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="roleLevel"
                                            id="roleLevel"
                                            name="roleLevel"
                                            value={role.roleLevel}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Role Level--</MenuItem>
                                            {generateDropDownMenu(roleLevel)}
                                        </Select>
                                        {errors["roleLevel"] && <FormHelperText error>{errors["roleLevel"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">

                                        <TextField fullWidth label="Role Name *"
                                            name="name"
                                            id="name"
                                            value={role.name}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["name"] && <span id="errbranchCode" className="text text-danger">{errors["name"]}</span>}
                                    </div>
                                </div>

                                <div>
                                    <label>Active</label>
                                    <div className="form-group row">
                                        <div className="col-md ">
                                            <input
                                                id="isActive"
                                                switch="none"
                                                className="mr-2"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={role.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, role)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}